<template>
<div>
<div class="login_wrap">
    <dl>
        <dt>비밀번호 설정</dt>
        <dd>
            비밀번호를 설정해주세요.
        </dd>
    </dl>

    <ul class="login_form">
        <li>
            <input type="password" placeholder="비밀번호 입력" v-model="password">
            <p class="new_password">영문, 숫자 조합 8자리 이상</p>
        </li>
        <li>
            <input type="password" placeholder="비밀번호 확인" v-model="passwordChk">
        </li>
    </ul>

    <div class="btn_box_fixed">
        <a class="default_btn1" @click="validate()">비밀번호 설정 완료</a>
    </div> 
</div>
</div>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { PasswordMixin } from '../../mixins/PasswordMixin';
export default 
{
    name:'JoinPassword',
    mixins:[PasswordMixin],
    
    created() {
        this.$store.commit('SHOW_ONLOAD');
    },
    mounted () {
        $('.login_wrap input').focus(function(){
            setTimeout(function () {
                $(".btn_box_fixed").css({"position":"unset","transform":"unset","width":"100%"});
            }, 100);
            
        });

        $('.login_wrap input').blur(function(){
            setTimeout(function () {
                $(".btn_box_fixed").css({"position":"fixed","transform":"translateX(-50%)","width":"100%"});
            }, 100);
        });
    },
    data() {
        return {
            password: '',
            passwordChk: '',
        }
    },
    computed: {
        ...mapState({
            authWrite: state => state.auth.itemWrite,
        })
    },
    methods: 
    {
        validate() 
        {
            try 
            {
                if (!this.password) throw '비밀번호를 입력해주세요.';
                
                let pwChk = this.chkPassword(this.password);

                if (pwChk) throw pwChk;

                if (!this.passwordChk) throw '비밀번호 확인을 입력해주세요.';
                if (this.password != this.passwordChk) throw '비밀번호가 일치하지 않습니다.';
            } 
            catch (error) 
            {
                this.$store.commit('OPEN_MODAL', {
                    content:error,
                    btnOne:'확인',
                })
                return;
            }
            
            this.submit();
        },

        submit(){
            this.authWrite.password = this.password;
            this.$router.push('/join/terms');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>